/**
 * Resolves the credit-repair operator subdomain for portal public branding and API host routing.
 */
export function getPortalSubdomain(): string {
  const fromQuery = new URLSearchParams(window.location.search).get("subdomain")?.trim().toLowerCase();
  if (fromQuery) {
    return fromQuery;
  }

  const fromEnv = process.env.REACT_APP_PORTAL_SUBDOMAIN?.trim().toLowerCase();
  if (fromEnv) {
    return fromEnv;
  }

  try {
    const raw = localStorage.getItem("portalUser");
    if (raw) {
      const u = JSON.parse(raw) as { subdomain?: string };
      if (u.subdomain) {
        return u.subdomain.toLowerCase();
      }
    }
  } catch {
    /* ignore */
  }

  const host = window.location.hostname.toLowerCase();
  if (host !== "localhost" && host !== "127.0.0.1") {
    const first = host.split(".")[0];
    if (first && first !== "www") {
      return first;
    }
  }

  return "freshstart";
}
